import { c as _c } from "react/compiler-runtime";
import { chakra, Checkbox, Circle, Flex, Heading, HStack, Icon, Stack, Text, VStack } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';
import { CreateRequestAnim } from '@src/components/sco/Animations/Requests/CreateRequestAnim';
import { ButtonLink } from '@src/components/sco/ButtonLink.tsx';
import ComponentCard from '@src/components/sco/LayoutBlocks/ComponentCard';
import LPBlock from '@src/components/sco/LayoutBlocks/LPBlock';
import SectionWrapper from '@src/components/sco/LayoutBlocks/SectionWrapper';
import { RequestAdvisorExampleCard } from '@src/components/sco/RequestRoadmap/RequestAdvisorExampleCard';
import { RequestMatchExample } from '@src/components/sco/RequestRoadmap/RequestMatchExample';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { LuChevronRight } from 'react-icons/lu';
export const RequestRoadmap = () => {
  const $ = _c(2);
  useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [<RequestOverviewCard key={0} />, <RequestTimeline key={1} />, <RequestFooter key={2} />];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SectionWrapper paddingX={0} paddingY={0} removeBottomPadding={true}><LPBlock cards={t0} paddingX={0} subtitle="You type what you need, we help you get it done." title="How We Help" textStackProps={{
        maxWidth: "800px"
      }} /></SectionWrapper>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const RequestOverviewCard = () => {
  const $ = _c(10);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  getBreakpointValue([true, true, false, false, false]);
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue(["column", "column", "column", "row"]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== getBreakpointValue) {
    t1 = getBreakpointValue([4, 4, 8, 8, 8]);
    $[2] = getBreakpointValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CreateRequestAnim />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <Flex align="center" alignSelf="stretch" bgColor="colorPalette.card" borderRadius="xl" boxShadow="md" color="white" flex={2} justify="center" padding={t1} position="relative" width="full">{t2}</Flex>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t3) {
    t4 = <ComponentCard bgColor="colorPalette.container/50" border="1px solid {colors.colorPalette.border/50}" btnColor="orange.400" btnCTA="Let's do this" btnHref="/requests/start" btnTextColor="colorPalette.bg" cardTitle="Post a Request" direction={t0} component={t3} description="Posting a Request captures your goal so we can build a plan and connect you with investors, advisors, co-founders, talent, and experts." />;
    $[7] = t0;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
const RequestTimeline = () => {
  const $ = _c(23);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t0 = isMobile ? 4 : 0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box bg="linear-gradient(to right, transparent, {colors.colorPalette.muted}, transparent)" borderRadius="xl" filter="blur(10px)" height="80%" left="50%" opacity={0.5} position="absolute" top="50%" transform="translate(-50%, -50%)" width="95%" zIndex={0} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isMobile ? "md" : "lg";
  let t3;
  if ($[1] !== t2) {
    t3 = <Flex align="center" gap={8} justify="center" marginBottom={12} maxWidth="540px" width="full"><Box alignItems="center" display="flex" justifyContent="center" position="relative" width="full">{t1}<Text color="red.fg" fontFamily="longform" fontSize={t2} fontStyle="italic" opacity={1} position="relative" textAlign="center" zIndex={1}>{"\"Based on your goal, we're going to connect you with early stage investors, review your pitch deck, and walk you through the steps to close your funding round."}</Text></Box></Flex>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isMobile ? "column" : "row";
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <RequestMatchExample noOfMatches="1,452" />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4) {
    t6 = <RequestTimelineCard direction={t4} title="Connect to People" visual={t5} description="Your goal is instantly matched to the right people using our AI-driven rankings, so you don't waste time on bad fits." />;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = isMobile ? "column" : "row-reverse";
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <RequestAdvisorExampleCard />;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t7) {
    t9 = <RequestTimelineCard direction={t7} title="Real Expert Advisory" visual={t8} description="Our startup advisors help you answer tough questions and identify what to focus on next through 1:1 sessions, workshops, or direct messages." />;
    $[7] = t7;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = isMobile ? "column" : "row";
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <RequestTaskListExample />;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== t10) {
    t12 = <RequestTimelineCard direction={t10} hideTimeline={true} title="Customized Education" visual={t11} description="We give you a step-by-step task list and targeted tools and content to help you complete your goal." />;
    $[10] = t10;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== t0 || $[13] !== t12 || $[14] !== t3 || $[15] !== t6 || $[16] !== t9) {
    t13 = <VStack align="center" gap={t0} width="full">{t3}{t6}{t9}{t12}</VStack>;
    $[12] = t0;
    $[13] = t12;
    $[14] = t3;
    $[15] = t6;
    $[16] = t9;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = isMobile ? "md" : "2xl";
  let t15;
  if ($[18] !== t14) {
    t15 = <Text color="colorPalette.fg" fontFamily="heading" fontSize={t14} fontWeight="600" maxWidth="800px" opacity={1} textAlign="center">Your Goal creates a Personalized Roadmap that provides step-by-step guidance to complete your goal.</Text>;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t13 || $[21] !== t15) {
    t16 = <ComponentCard cardDescriptionSize="2xl" cardTitle="Requests = Personalized Roadmap" direction="column" flexAlign="center" textAlign="center" component={t13} customDescription={t15} />;
    $[20] = t13;
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  return t16;
};
const RequestTimelineCard = props => {
  const $ = _c(49);
  const {
    title,
    description,
    direction: t0,
    visual,
    hideTimeline: t1
  } = props;
  const direction = t0 === undefined ? "row" : t0;
  const hideTimeline = t1 === undefined ? false : t1;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t2 = isMobile ? "center" : "normal";
  const t3 = isMobile ? "center" : "center";
  const t4 = isMobile ? 4 : 0;
  let t5;
  if ($[0] !== getBreakpointValue) {
    t5 = getBreakpointValue(["lg", "lg", "3xl", "3xl", "3xl"]);
    $[0] = getBreakpointValue;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = isMobile ? "center" : "start";
  let t7;
  if ($[2] !== t5 || $[3] !== t6 || $[4] !== title) {
    t7 = <Heading maxWidth="400px" size={t5} textAlign={t6} width="full">{title}</Heading>;
    $[2] = t5;
    $[3] = t6;
    $[4] = title;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== getBreakpointValue) {
    t8 = getBreakpointValue(["sm", "sm", "xl", "xl", "xl"]);
    $[6] = getBreakpointValue;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = isMobile ? "center" : "start";
  let t10;
  if ($[8] !== description || $[9] !== t8 || $[10] !== t9) {
    t10 = <Text color="fg.muted" fontFamily="longform" fontSize={t8} maxWidth="400px" textAlign={t9}>{description}</Text>;
    $[8] = description;
    $[9] = t8;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t3 || $[14] !== t4 || $[15] !== t7) {
    t11 = <VStack align={t3} gap={2} justify="center" marginBottom={t4} width="full">{t7}{t10}</VStack>;
    $[12] = t10;
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== getBreakpointValue) {
    t12 = getBreakpointValue(["60px", "60px", "200px", "200px", "200px"]);
    $[17] = getBreakpointValue;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12) {
    t13 = <Box border="2px dashed" borderColor="colorPalette.border" flexGrow={1} height="full" minHeight={t12} opacity={0.75} width="4px" />;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== getBreakpointValue) {
    t14 = getBreakpointValue(["2px solid", "2px solid", "6px solid", "6px solid", "6px solid"]);
    $[21] = getBreakpointValue;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== getBreakpointValue) {
    t15 = getBreakpointValue(["4", "4", "8", "8", "8"]);
    $[23] = getBreakpointValue;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t14 || $[26] !== t15) {
    t16 = <Circle bgColor="colorPalette.muted" border={t14} borderColor="colorPalette.border" boxShadow="lg" size={t15} />;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  const t17 = isMobile ? "none" : "block";
  let t18;
  if ($[28] !== getBreakpointValue) {
    t18 = getBreakpointValue(["60px", "60px", "200px", "200px", "200px"]);
    $[28] = getBreakpointValue;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t17 || $[31] !== t18) {
    t19 = <Box border="2px dashed" borderColor="colorPalette.border" display={t17} flexGrow={1} height="full" minHeight={t18} opacity={0.75} width="4px" />;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t13 || $[34] !== t16 || $[35] !== t19) {
    t20 = <Box><VStack align="center" gap={0} justify="start" paddingX={12} width="auto">{t13}{t16}{t19}</VStack></Box>;
    $[33] = t13;
    $[34] = t16;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== visual) {
    t21 = <Flex align="center" justify="center" width="full">{visual}</Flex>;
    $[37] = visual;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== getBreakpointValue || $[40] !== hideTimeline) {
    t22 = !hideTimeline && <Box hideFrom="md"><VStack align="center" gap={0} justify="start" width="auto"><Circle bgColor="colorPalette.muted" border={getBreakpointValue(["2px solid", "2px solid", "4px solid", "4px solid", "4px solid"])} borderColor="colorPalette.border/50" boxShadow="lg" size={getBreakpointValue(["4", "4", "8", "8", "8"])} /><Box border="2px dashed" borderColor="colorPalette.border" height="75px" opacity={0.75} width="4px" /></VStack></Box>;
    $[39] = getBreakpointValue;
    $[40] = hideTimeline;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== direction || $[43] !== t11 || $[44] !== t2 || $[45] !== t20 || $[46] !== t21 || $[47] !== t22) {
    t23 = <Stack align={t2} direction={direction} gap={0} justify="center" width="full">{t11}{t20}{t21}{t22}</Stack>;
    $[42] = direction;
    $[43] = t11;
    $[44] = t2;
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  return t23;
};
const RequestFooter = () => {
  const $ = _c(15);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([4, 4, 10, 10, 10]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== getBreakpointValue) {
    t1 = getBreakpointValue([4, 4, 10, 10, 10]);
    $[2] = getBreakpointValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isMobile ? "3xl" : "5xl";
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    t4 = <chakra.span color="purple.focusRing">Three clear paths to execution.</chakra.span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2) {
    t5 = <Heading size={t2} textAlign="center">One goal. One roadmap.{t3}{t4}</Heading>;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = isMobile ? "lg" : "xl";
  let t7;
  if ($[8] !== t6) {
    t7 = <ButtonLink href="/requests/start" size={t6} variant="cta">Build My Roadmap</ButtonLink>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t5 || $[13] !== t7) {
    t8 = <Flex align="center" direction="column" gap={t0} justify="center" paddingY={t1} width="full">{t5}{t7}</Flex>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
const RequestTaskListExample = () => {
  const $ = _c(17);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t0 = isMobile ? 4 : 0;
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([4, 4, 6, 6, 6]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isMobile ? "md" : "lg";
  let t3;
  if ($[2] !== t2) {
    t3 = <Heading size={t2}>Next Steps</Heading>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isMobile ? "xs" : "sm";
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon asChild={true}><LuChevronRight /></Icon>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = <Button size={t4}>View Completed{t5}</Button>;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3 || $[8] !== t6) {
    t7 = <HStack align="center" direction="row" gap={0} justify="space-between" marginBottom={2} width="full">{t3}{t6}</HStack>;
    $[7] = t3;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ExampleTaskArray.map(_temp);
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t1 || $[12] !== t7) {
    t9 = <VStack align="center" gap={2} justify="center" padding={t1} width="full">{t7}{t8}</VStack>;
    $[11] = t1;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t0 || $[15] !== t9) {
    t10 = <VStack align="center" background="colorPalette.container" border="1px solid" borderColor="colorPalette.border" borderRadius="xl" boxShadow="md" gap={0} justify="center" marginTop={t0} padding={0} width="full">{t9}</VStack>;
    $[14] = t0;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
const RequestTaskExampleCard = props => {
  const $ = _c(25);
  const {
    title,
    description,
    completed: t0
  } = props;
  const completed = t0 === undefined ? false : t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMobile = t1;
  const t2 = isMobile ? "center" : "start";
  const t3 = completed ? "colorPalette.card" : "colorPalette.card/20";
  const t4 = completed ? "1px solid" : "none";
  const t5 = completed ? "colorPalette.border" : "transparent";
  let t6;
  if ($[2] !== getBreakpointValue) {
    t6 = getBreakpointValue([3, 3, 4, 4, 4]);
    $[2] = getBreakpointValue;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Checkbox.HiddenInput />;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Checkbox.Control><Checkbox.Indicator /></Checkbox.Control>;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== completed) {
    t9 = <Checkbox.Root defaultChecked={completed} size="md">{t7}{t8}</Checkbox.Root>;
    $[6] = completed;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const t10 = isMobile ? "normal" : "100%";
  let t11;
  if ($[8] !== t10 || $[9] !== title) {
    t11 = <Heading lineHeight={t10} size="sm">{title}</Heading>;
    $[8] = t10;
    $[9] = title;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== description || $[12] !== isMobile) {
    t12 = !isMobile && <Text fontSize="xs">{description}</Text>;
    $[11] = description;
    $[12] = isMobile;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t11 || $[15] !== t12) {
    t13 = <VStack align="start" gap={1} justify="center" width="full">{t11}{t12}</VStack>;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t9) {
    t14 = <Stack align={t2} background={t3} border={t4} borderColor={t5} borderRadius="md" direction="row" gap={2} justify="center" padding={t6} width="full">{t9}{t13}</Stack>;
    $[17] = t13;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t9;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
};
const ExampleTaskArray = [{
  title: 'Upload Pitch Deck for Analysis',
  description: 'Get feedback on clarity, story, and gaps that may slow investor interest.'
}, {
  title: 'Schedule 1:1 Review with Pitch Deck Expert',
  description: 'Pressure-test your deck with an experienced founder and refine key slides.'
}, {
  title: 'Review Investor Matches to Contact',
  description: 'Focus on high-fit investors who align with your stage and goals.'
}, {
  title: 'Draft Investor Outreach Emails',
  description: 'Craft concise messages that highlight traction and spark responses.'
}];
function _temp(task) {
  return <RequestTaskExampleCard key={task.title} completed={ExampleTaskArray.indexOf(task) === 0} description={task.description} title={task.title} />;
}